<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import TestimonialsSlider from '@/pages/HomePage/Testimonials/TestimonialsSlider.vue';

import backgroundImage from '@/assets/home/testimonials.png';

const { t } = useI18n();
</script>

<template>
  <div class="testimonials-section container flex flex-col pt-24">
    
    <div class="w-full mb-10">
      <span class="responsive-title-5 font-semibold">{{ t('testimonials.title') }}</span>
    </div>
    
    <div class="testimonial-b flex w-full h-[514px] bg-cover bg-center px-20 pt-20 pb-8"
         :style="{ backgroundImage: `url(${backgroundImage})` }">
      
      <div class="w-2/5 flex flex-col justify-between">
        <div class="w-1/2 responsive-title-2">
          {{ t('testimonials.subtitle') }}
        </div>
      </div>
      
      <div class="w-3/5">
        <TestimonialsSlider />
      </div>

    </div>

  </div>
</template>

<style scoped>
@media (max-width: 768px) {
  .testimonial-b{
  padding-left:  1rem;
    padding-right:  1rem;
    }
}
</style>